<div class="confirm-dialog">

  <div class="dialog-icon">
    <mat-icon>help_outline</mat-icon>
  </div>

  <div
    mat-dialog-content
    class="dialog-message"
  >
    {{ data.message |translate }}
  </div>

  <div
    mat-dialog-actions
    class="dialog-actions"
  >

    <button
      mat-button
      type="button"
      class="cancel-btn"
      (click)="onCancel()"
    >
      {{'COMMON.CANCEL' | translate}}
    </button>

    <button
      mat-raised-button
      type="button"
      class="confirm-btn"
      (click)="onConfirm()"
    >
      <mat-icon>check</mat-icon>
      {{'COMMON.CONFIRM' | translate}}
    </button>

  </div>

</div>